var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 100,
    viewBox: "0 0 202 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 99.4995C196.5 74.4996 147.5 25.9997 123 30.4997C98.5 34.9997 65.4863 87.7766 40 71.4999C22.2743 60.1795 20.5 34.0001 20.5 34.0001",
    stroke: "#BFBFC5",
    strokeDasharray: "4 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_3723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0454 30.5405C18.2329 25.5248 16.3916 20.4294 14.5791 15.4137C14.4995 15.4425 14.4995 15.4425 14.4199 15.4712C14.7919 17.4971 15.0555 19.472 15.4275 21.4979C15.5272 22.272 15.7065 23.0173 15.835 23.8709C15.928 24.3774 15.8042 24.7822 15.3553 25.0344C13.1395 26.3752 10.9524 27.7956 8.65701 29.1651C8.44693 29.3311 8.23686 29.497 8.02009 29.3953C7.69493 29.2428 7.84747 28.9176 7.84077 28.65C8.55116 20.6523 9.23278 12.575 10.0228 4.54861C10.0957 4.25223 9.95186 3.85415 10.2703 3.73908C10.6684 3.59523 10.8122 3.9933 11.0865 4.25422C16.7453 9.9503 22.4041 15.6464 28.0629 21.3425C28.2289 21.5525 28.554 21.7051 28.4811 22.0015C28.4082 22.2978 28.0322 22.2537 27.7646 22.2604C25.3627 22.5883 22.9609 22.9161 20.5591 23.244C19.785 23.3437 19.5241 23.618 19.6238 24.3921C19.8011 26.1282 19.9276 27.9727 20.1049 29.7089C20.1116 29.9765 20.147 30.3237 20.1537 30.5913C20.125 30.5117 20.0454 30.5405 20.0454 30.5405Z",
    fill: "#BFBFC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_3723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9253,
    height: 28.6129,
    fill: "white",
    transform: "translate(0 7.45117) rotate(-19.868)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.41495a08920c03e4ed8b3bee3a48f7de.svg";
export { ForwardRef as ReactComponent };